<template>
  <div class="doctor_show">
    <div class="doctor_center">
      <!--顶部图片-->
      <div class="top_box">
        <img class="bg" src="../../../assets/images/home/u10271.png" alt="">
        <div class="doctor_info_abs">
          <div class="doctor_info">
            <img :src="DoctorInfo.headImage" alt="">
            <div class="doctor_name">
              <div>{{DoctorInfo.doctorName}}</div>
              <span>{{DoctorInfo.doctorLevelName}}</span>
            </div>
            <div class="doctor_Hospital">
              <div>{{DoctorInfo.hospitalName}}</div>
              <span>{{DoctorInfo.departmentName}}</span>
            </div>
            <div class="doctor_introduce">
              <span>擅长：</span>
              {{DoctorInfo.doctorSkill}}</div>
          </div>
        </div>
      </div>
      <!--他的贡献-->
      <div class="contribute">
        <div class="contribute_header">
          <div></div>
          <span>他的贡献</span>
          <div></div>
        </div>
        <div class="contribute_card">
          <div @click="handleGoList(1)" :class="{active:this.$route.params.type==1}" class="item_card">
            <div class="wrap">
              <img width="59px" height="50px" src="../../../assets/images/home/u10232.png" alt="">
              <div>视频</div>
              <span>{{DoctorInfo.videoCount}}</span>
            </div>
          </div>
          <div @click="handleGoList(2)" :class="{active:this.$route.params.type==2}" class="item_card">
            <div class="wrap">
              <img width="50px" height="50px" src="../../../assets/images/home/u10222.png" alt="">
              <div>语音</div>
              <span>{{DoctorInfo.voiceCount}}</span>
            </div>
          </div>
          <div v-if="0" @click="handleGoList(3)" :class="{active:this.$route.params.type==3}" class="item_card">
            <div class="wrap">
              <img width="46px" height="50px" src="../../../assets/images/home/u10248.png" alt="">
              <div>文章</div>
              <span>35</span>
            </div>
          </div>
          <div @click="handleGoList(4)" :class="{active:this.$route.params.type==4}" class="item_card">
            <div class="wrap">
              <img width="50px" height="50px" src="../../../assets/images/home/u10262.png" alt="">
              <div>问答</div>
              <span>{{DoctorInfo.askCount}}</span>
            </div>
          </div>
        </div>
      </div>
      <!--二级路由显示-->
      <div class="router_box">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Show",
    data(){
      return {
        DoctorInfo:{},
      }
    },
    methods:{
      handleGoList(val){
        if(!val) val = 1
        this.$router.push({path:'/tt/salientDoctor/salientDoctorShow/doctorNavList/'+this.$route.params.id+'/'+val+'.html',query:{}})
      },
      getDoctorShow() {
        let params = {
          doctorId:this.$route.params.id
        }
        this.$api.mykp_home.findDoctorShow(params) .then(res => {
          if(res.code == '000000') {
            this.DoctorInfo = res.infos
          }
        })
      },
    },
    activated() {
      this.handleGoList()
      this.getDoctorShow()
       var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?26e3d1e8dc2b426ced392180fb72861b";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
      console.log("统计")
    },
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .doctor_show{
    .doctor_center{
      width: 1200px
      margin 0 auto
      .top_box{
        width: 100%
        height: 350px
        position relative
        .bg{
          width: 100%
        }
        .doctor_info_abs{
          position absolute
          left 40px
          top: 0
          width: 400px
          height: 100%
          display flex
          align-items center
          justify-content center
          .doctor_info{
            display flex
            flex-direction column
            align-items center
            >img{
              width: 150px;
              height: 150px;
              border-radius 50%
            }
            .doctor_name{
              display flex
              margin-top 15px
              align-items center
              >div{
                font-weight: 700;
                font-style: normal;
                font-size: 18px;
                color: #000000;
                margin-right 25px
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width 150px
              }
              >span{
                width: 85px;
                height: 31px;
                background #1083f8
                font-size: 16px;
                color: #fff;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width 150px
                border-radius: 5px;
                text-align: center
                line-height:31px
              }
            }
            .doctor_Hospital{
              display flex
              margin-top 20px
              >div{
                font-size: 14px;
                color: #000000;
                margin-right 20px
              }
              >span{
                font-size: 14px;
                color: #000000;
              }
            }
            .doctor_introduce{
              margin-top 15px
              font-size: 14px;
              color: #000000;
              line-height: 24px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
              >span{

                font-size: 14px;
                color: #000000;
                line-height: 24px;
                font-weight  700
              }
            }
          }
        }
      }
      .contribute{
        .contribute_header{
          margin 40px 0
          display flex
          align-items center
          >span{
            display block
            font-weight: 700;
            font-style: normal;
            font-size: 20px;
            color: #199ED8;
            margin 0 20px
          }
          >div{
            background #e7e7e7
            height: 1px
            flex 1
          }
        }
        .contribute_card{
          display flex
          align-items center
          justify-content space-around
          .item_card{
            width: 285px;
            height: 172px;
            border-radius: 7px;
            border 1px solid #199ed8
            display flex
            align-items center
            justify-content center
            &:hover{
              border-width:3px
            }
            &.active{
              border-width:3px
            }
            .wrap{
              width: 150px
              height: 150px
              display flex
              align-items center
              justify-content center
              flex-direction column
              >img{
                vertical-align middle
                margin-top 5px
              }
              >div{
                font-weight: 700;
                font-size: 20px;
                color: #199ED8;
                margin-top 20px
              }
              >span{
                font-weight: 700;
                font-size: 20px;
                color: #199ED8;
                margin-top 10px
              }
            }
          }
        }
      }
      .router_box{
        width: 100%
        margin-top 30px
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/view-tt/salientDoctor/Show.vue